var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteOrangeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12184",
    "data-name": "Group 12184",
    transform: "translate(10041 -1110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(-10041 1110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.875,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "delete_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M161.979-828.125a1.27,1.27,0,0,1-.932-.388,1.27,1.27,0,0,1-.388-.932v-8.577a.638.638,0,0,1-.47-.19.638.638,0,0,1-.19-.47.638.638,0,0,1,.19-.47.638.638,0,0,1,.47-.19H163.3a.638.638,0,0,1,.19-.47.638.638,0,0,1,.47-.19H166.6a.638.638,0,0,1,.47.19.638.638,0,0,1,.19.47H169.9a.638.638,0,0,1,.47.19.638.638,0,0,1,.19.47.638.638,0,0,1-.19.47.638.638,0,0,1-.47.19v8.577a1.27,1.27,0,0,1-.388.932,1.271,1.271,0,0,1-.932.388Zm1.979-2.639a.639.639,0,0,0,.47-.19.638.638,0,0,0,.19-.47v-4.618a.638.638,0,0,0-.19-.47.639.639,0,0,0-.47-.19.639.639,0,0,0-.47.19.638.638,0,0,0-.19.47v4.618a.638.638,0,0,0,.19.47A.639.639,0,0,0,163.959-830.763Zm2.639,0a.639.639,0,0,0,.47-.19.639.639,0,0,0,.19-.47v-4.618a.639.639,0,0,0-.19-.47.639.639,0,0,0-.47-.19.639.639,0,0,0-.47.19.638.638,0,0,0-.19.47v4.618a.638.638,0,0,0,.19.47A.639.639,0,0,0,166.6-830.763Z",
    transform: "translate(-10194.181 1956.16)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOrangeIcon);
export default __webpack_public_path__ + "static/media/delete_orange_icon.66d91cae6223a5429010da3deb844d1f.svg";
export { ForwardRef as ReactComponent };